// types.ts

import { FiltersPlugin } from "@me8eon/filters/src/filters.plugin";
import { SimpleDisplayDepartmentTypeFilter } from "./department.type.filter";

export const departmentTypeFilterPluginName = "departmentType";

// These values come from API, so define type as `string`
export type DepartmentTypeString = string;

export type DepartmentTypeFilters = {
    [departmentTypeFilterPluginName]: DepartmentTypeString;
};

export const departmentTypeFilterPlugin: FiltersPlugin<DepartmentTypeFilters, "departmentType"> = {
    plugin: "filter",
    type: departmentTypeFilterPluginName,
    changeCausesSubmit: true,
    deleteWhenClean: true,
    DefaultDisplay: SimpleDisplayDepartmentTypeFilter,
};
